import { createContext } from 'react';

// Site version key of each site modal mapped to the node type it holds.
export const SITE_MODAL_NODE_TYPE_BY_KEY = {
  signup_modal: 'signupModal',
  recommendations_modal: 'recommendationsModal',
  login_modal: 'loginModal',
};

export const SITE_MODAL_NODE_TYPES: string[] = Object.values(SITE_MODAL_NODE_TYPE_BY_KEY);

export const SiteModalSlotContext = createContext(false);
